import AsideLayout from '../baseLayouts/AsideLayout';

export const withSupportLayout = (Component: React.ComponentType) => {
  const WrappedComponent = (props: any) => (
    <AsideLayout>
      <Component {...props} />
    </AsideLayout>
  );
  return WrappedComponent;
};
